// extracted by mini-css-extract-plugin
export default {"shopping-cart-page__loader-wrapper":"shopping-cart-page__loader-wrapper__TELrjtT"};